import "./WorldImmigrationVideo.module.css";
import Header from "@/reusable_sections/Header";
import Calendly from "./sections/Calendly";
import Footer from "@/reusable_sections/Footer";
export default function WorldImmigrationVideoPage() {
  return <div>
      <Header />
      <Calendly />
      <Footer />
    </div>;
}